import { g as r } from "./isObjectLike.2a90a4b2.js";
function t(i) {
  return i == null;
}
var o = t;
const l = /* @__PURE__ */ r(o);
export {
  l as i
};
//# sourceMappingURL=isNil.6f60d6a4.js.map
